import assign from "lodash-es/assign";
import omit from "lodash-es/omit";

export default function fieldsHydrator(fields, newFields) {
  newFields.forEach(function (newField) {
    if (!fields.get(newField.attribute)) {
      return;
    }

    let field = fields.get(newField.attribute);

    assign(field, omit(newField, ["value"]));
  });
}
